import React from "react"
import { BrowserRouter } from "react-router-dom"

import { Router } from "router/Router"
import ScrollToTop from "components/shared/ScrollToTop"
import { Seo } from "components/Seo"
import Providers from "components/Providers"

const App = () => {
	const basename = process.env.REACT_APP_BASENAME || undefined
	return (
		<BrowserRouter basename={basename}>
			<Providers>
				<Seo />
				<ScrollToTop />
				<Router />
			</Providers>
		</BrowserRouter>
	)
}

export default App
